const oldList = [{
        path: "/houseDetail",
        name: "HouseDetail",
        component: () =>
            import ("@/views/old/houseDetail.vue"),
        meta: {
            title: "房屋详情"
        }
    },
    {
        path: "/projectDetailIndex",
        name: "ProjectDetailIndex",
        component: () =>
            import ("@/views/old/projectDetailIndex.vue"),
        meta: {
            title: "小区详情"
        }
    },
    {
        path: "/oldProjectDetail",
        name: "OldProjectDetail",
        component: () =>
            import ("@/views/old/oldProjectDetail.vue"),
        meta: {
            title: "楼盘详情"
        }
    },
    {
        path: "/findProject",
        name: "FindProject",
        component: () =>
            import ("@/views/old/findProject.vue"),
        meta: {
            title: "找小区"
        }
    },
    {
        path: "/signWithMe",
        name: "SignWithMe",
        component: () =>
            import ("@/views/old/signWithMe.vue"),
        meta: {
            title: "与我签约"
        }
    },
    {
        path: "/announceMechanism",
        name: "AnnounceMechanism",
        component: () =>
            import ("@/views/old/announceMechanism.vue"),
        meta: {
            title: "房产机构公示"
        }
    },
    {
        path: "/announceMedia",
        name: "AnnounceMedia",
        component: () =>
            import ("@/views/old/announceMedia.vue"),
        meta: {
            title: "门店公示"
        }
    },
    {
        path: "/mechanismDetail",
        name: "MechanismDetail",
        component: () =>
            import ("@/views/old/mechanismDetail.vue"),
        meta: {
            title: "房产机构详情"
        }
    },
    {
        path: "/shopDetail",
        name: "ShopDetail",
        component: () =>
            import ("@/views/old/shopDetail.vue"),
        meta: {
            title: "门店详情"
        }
    },
    {
        path: "/houseOraList",
        name: "HouseList",
        component: () =>
            import ("@/views/old/houseList.vue"),
        meta: {
            title: "房源"
        }
    },
    {
        path: "/sellHouse",
        name: "SellHouse",
        component: () =>
            import ("@/views/old/sellHouse.vue"),
        meta: {
            title: "业主直卖"
        }
    },
    {
        path: "/sameHouseList",
        name: "sameHouseList",
        component: () =>
            import ("@/views/old/sameHouseList.vue"),
        meta: {
            title: "同小区房源"
        }
    },

    {
        path: "/secondHouseList",
        name: "secondHouseList",
        component: () =>
            import ("@/views/old/secondHouseList.vue"),
        meta: {
            title: "二手房源"
        }
    },
    {
        path: "/personList",
        name: "PersonList",
        component: () =>
            import ("@/views/old/personList.vue"),
        meta: {
            title: "经纪人"
        }
    },
    {
        path: "/personListMain",
        name: "PersonListMain",
        component: () =>
            import ("@/views/old/personListMain.vue"),
        meta: {
            title: "经纪人"
        }
    },
    {
        path: "/shopList",
        name: "ShopList",
        component: () =>
            import ("@/views/old/shopList.vue"),
        meta: {
            title: "门店"
        }
    },
    {
        path: "/checkHouse",
        name: "CheckHouse",
        component: () =>
            import ("@/views/old/checkHouse.vue"),
        meta: {
            title: "房源核验"
        }
    },
    {
        path: "/rankOld",
        name: "RankOld",
        component: () =>
            import ("@/views/old/rankOld.vue"),
        meta: {
            title: "排行榜"
        }
    },
    {
        path: "/oldPhoto",
        name: "OldPhoto",
        component: () =>
            import ("@/views/old/oldPhoto.vue"),
        meta: {
            title: "排行榜"
        }
    },
    {
        path: "/kfRecord",
        name: "KfRecord",
        component: () =>
            import ("@/views/old/kfRecord.vue"),
        meta: {
            title: "看房记录"
        }
    },
    {
        path: "/tfyRecord",
        name: "TfyRecord",
        component: () =>
            import ("@/views/old/tyfRecord.vue"),
        meta: {
            title: "同房源挂牌记录"
        }
    },
    {
        path: "/cjRecord",
        name: "CjRecord",
        component: () =>
            import ("@/views/old/cjRecord.vue"),
        meta: {
            title: "成交记录"
        }
    },
    {
        path: "/oldMap",
        name: "OldMap",
        component: () =>
            import ("@/views/old/oldMap.vue"),
        meta: {
            title: "地图找房"
        }
    },
    {
        path: "/infoCompletion",
        name: "InfoCompletion",
        component: () =>
            import ("@/views/old/infoCompletion.vue"),
        meta: {
            title: "买方信息补全",
            isLogin: true
        }
    },
];
export default oldList;